export default {"src":"/evde-internet/_next/static/media/red-simcard.083eb1fc.svg","height":32,"width":32};